export default __webpack_public_path__ + "static/X05-95cde83bdf744e4b4b365f5ec616ad7c.png";